import { Component } from '@angular/core';

@Component({
  selector: 'app-cards7-examples-48',
  templateUrl: './cards7-examples-48.component.html'
})
export class Cards7Examples48Component {}
